import React,{ Component } from 'react';
import {Col, Row, Card, CardBody, Spinner, CardHeader, Progress, Collapse, Button } from "reactstrap";
import { Line } from 'react-chartjs-2';
import moment from "moment";
import { withRouter, Link } from "react-router-dom";
import { CustomTooltips } from '@coreui/coreui-plugin-chartjs-custom-tooltips';
import KasmTable from "./KasmTable";


const makeSparkLineData = (labels, data, variant, label) => {
    const convertedLabels = labels && labels.map((label, i) => {
        return moment.utc(label,"YYYYMMDDHHmm").local().format("MM/DD LT")
    });
    const graph = {
        labels:convertedLabels,
        datasets: [
            {
                backgroundColor: 'transparent',
                borderColor: variant ? variant : '#c2cfd6',
                data: data,
                label:label ? label : "data"
            },
        ],
    };
    return () => graph;
};

const sparklineChartOpts = {
    tooltips: {
        enabled: false,
        custom: CustomTooltips
    },
    hover: {
        mode: 'index',
        intersect: false
    },
    responsive: true,
    maintainAspectRatio: true,
    scales: {
        xAxes: [
            {
                display: false,
            }],
        yAxes: [
            {
                display: false,
            }],
    },
    elements: {
        line: {
            borderWidth: 2,
            tension: .4,
        },
        point: {
            radius: 0,
            hitRadius: 10,
            hoverRadius: 4,
            hoverBorderWidth: 3,
        },
    },
    legend: {
        display: false,
    },
    layout: {
        padding: {
            left: 10,
            right: 10,
            top: 10,
            bottom: 10
        }
    },
};

const chartwrapper = {
    position: 'absolute',
    top: '10px',
    left: '50%',
    float: 'right',
    width: '50%'
};

const max = arr => arr !== undefined && arr.reduce((a,b) => Math.max(a,b));
const sum = arr => arr !== undefined && arr.reduce((a,b) => a + b, 0);

class Tabs extends Component {
    constructor(props) {
        super(props);
    }


    formatSeconds(secs) {
        if (secs < 60) {
            return <div><strong>{secs}</strong>s</div>
        } else if (secs < 3600) {
            let minutes = Math.floor(secs / 60);
            let seconds = secs % 60;
            return <div><strong>{minutes}</strong>m <strong>{seconds}</strong>s</div>
        } else {
            let hour = Math.floor(secs / 3600);
            secs = secs - hour * 3600;
            let minutes = Math.floor(secs / 60);
            let seconds = secs % 60;
            return <div><strong>{hour}</strong>h <strong>{minutes}</strong>m <strong>{seconds}</strong>s</div>
        }
    }

    render() {
        const {active_users, logins_by_hour, images, kasms, current_users, current_kasms} = this.props;
        const {getLoginsLoading, getActiveUsersLoading, getKasmLengthLoading,
               getErrorLoading, getKasmsLoading, getImageUseLoading,
               getCurrentUsersLoading, getCurrentKasmLoading } = this.props;
        let img_data = [];
        let img_progress = null;
        if(images && images.data) {
            if (images) {
                for (let x in images.data) {
                    img_data.push(images.data[x].count);
                }
            }
            let arr = JSON.parse(JSON.stringify(images.data));
            arr.sort((a, b) => {
                if (a.count === b.count) {
                    return 0
                } else if (a.count < b.count) {
                    return 1
                } else {
                    return -1
                }
            });
            let max_img = sum(img_data);
            img_progress= arr.map((data, i) => {
                return <div key={i} className="progress-group">
                    <div className="progress-group-header">
                        <img className="progress-group-icon" src={data.image_src}/>
                        <span className="title"><strong>{data.friendly_name}</strong></span>
                        <span className="ml-auto font-weight-bold">{data.count ? Math.round((data.count / max_img) * 100) : 0}%</span>
                    </div>
                    <div className="progress-group-bars">
                        <Progress style={{height: '4px'}} color="warning" value={(data.count / max_img) * 100}/>
                    </div>
                </div>
            });
        }
        return (
            <React.Fragment>
                <CardBody>
                    <Row>
                        <Col xs="12">
                            <Row>
                                <Col sm="6" xl="3" style={{minWidth: '275px'}}>
                                    <div className="callout border-info">
                                        <small className="text-muted">Max Active Users</small>
                                        <br />
                                        {getActiveUsersLoading ? <Spinner color="primary"/> :
                                            <React.Fragment>
                                                {active_users &&
                                                    <React.Fragment>
                                                        <strong className="h4">{active_users.users && max(active_users.users)}</strong>
                                                        <div style={chartwrapper}>
                                                            <Line
                                                                data={makeSparkLineData(active_users.labels, active_users.users, "#33b5e5", "Users:")}
                                                                options={sparklineChartOpts} width={100} height={30}/>
                                                        </div>
                                                    </React.Fragment>
                                                }
                                            </React.Fragment>
                                        }
                                    </div>
                                </Col>
                                <Col sm="6" xl="3" style={{minWidth: '275px'}}>
                                    <div className="callout border-success">
                                        <small className="text-muted">Successful Logins</small>
                                        <br />
                                        {getLoginsLoading ? <Spinner color="success"/> :
                                            <React.Fragment>
                                                {logins_by_hour &&
                                                <React.Fragment>
                                                    <strong className="h4">
                                                        <Link
                                                            to={{
                                                                pathname: '/logging',
                                                                state: {
                                                                    level: 'INFO',
                                                                    search: 'Successful authentication attempt',
                                                                    start_date: this.props.selectOpen ? this.props.start_date : null,
                                                                    end_date: this.props.selectOpen ? this.props.end_date: null,
                                                                    delta: this.props.delta,
                                                                }
                                                            }}
                                                        >
                                                            {sum(logins_by_hour.success_login)}
                                                        </Link>
                                                    </strong>
                                                    <div style={chartwrapper}>
                                                        <Line
                                                            data={makeSparkLineData(logins_by_hour.labels, logins_by_hour.success_login, "#007E33", "Logins:")}
                                                            options={sparklineChartOpts} width={100} height={30}/>
                                                    </div>
                                                </React.Fragment>}
                                            </React.Fragment>
                                        }
                                    </div>
                                </Col>
                                <Col sm="6" xl="3" style={{minWidth: '275px'}}>
                                    <div className="callout border-danger">
                                        <small className="text-muted">Failed Logins</small>
                                        <br />
                                        {getLoginsLoading ? <Spinner color="danger"/> :
                                            <React.Fragment>
                                                {logins_by_hour &&
                                                    <React.Fragment>
                                                        <strong className="h4">
                                                            <Link
                                                                to={{
                                                                    pathname: '/logging',
                                                                    state: {
                                                                        level: 'WARNING',
                                                                        search: 'attempt',
                                                                        start_date: this.props.selectOpen ? this.props.start_date : null,
                                                                        end_date: this.props.selectOpen ? this.props.end_date: null,
                                                                        delta: this.props.delta,
                                                                    }
                                                                }}
                                                            >
                                                                {sum(logins_by_hour.failed_login)}
                                                            </Link>
                                                        </strong>
                                                        <div style={chartwrapper}>
                                                            <Line data={makeSparkLineData(logins_by_hour.labels, logins_by_hour.failed_login, "#CC0000", "Failed Logins:")} options={sparklineChartOpts} width={100} height={30} />
                                                        </div>
                                                    </React.Fragment>}
                                            </React.Fragment>}
                                    </div>
                                </Col>
                                <Col sm="6" xl="3" style={{minWidth: '275px'}}>
                                    <div className="callout border-warning">
                                        <small className="text-muted">Created Sessions</small>
                                        <br />
                                        {getKasmsLoading ? <Spinner color="warning"/> :
                                            <React.Fragment>
                                                {kasms &&
                                                    <React.Fragment>
                                                        <strong className="h4">
                                                            <Link
                                                                to={{
                                                                    pathname: '/logging',
                                                                    state: {
                                                                        level: 'INFO',
                                                                        search: 'Creating Kasm',
                                                                        start_date: this.props.selectOpen ? this.props.start_date : null,
                                                                        end_date: this.props.selectOpen ? this.props.end_date: null,
                                                                        delta: this.props.delta,
                                                                    }
                                                                }}
                                                            >
                                                                {this.props.created_kasms ? this.props.created_kasms : 0}
                                                            </Link>
                                                        </strong>
                                                        <div style={chartwrapper}>
                                                            <Line data={makeSparkLineData(kasms.labels, kasms.kasms, "#ffbb33", "Sessions:")} options={sparklineChartOpts} width={100} height={30} />
                                                        </div>
                                                    </React.Fragment>}
                                            </React.Fragment>}
                                    </div>
                                </Col>
                            </Row>
                            <hr className="mt-0" />
                            <Row className="p-2"  >
                                <Col md={6} className="scalar_reports" style={{minWidth: '305px', paddingTop: '15px'}}>
                                    <h4>Current Statistics</h4>
                                    <Row style={{minWidth: '340px'}}>
                                        <Col md={6} style={{paddingBottom: '15px'}}>
                                            <div style={{display:'inline-flex', paddingTop:'5px'}}>
                                                <div>
                                                    <i className="fa fa-laptop bg-info font-2xl p-3 mr-3" />
                                                </div>
                                                <div>
                                                    <strong className={"text-primary"} style={{whiteSpace: 'nowrap'}}>
                                                        {getKasmLengthLoading ? <React.Fragment><Spinner size={'sm'} color={'primary'} /><br/></React.Fragment>
                                                            :
                                                            <React.Fragment>
                                                            { this.props.average_kasm_duration ?
                                                                this.formatSeconds(Math.round(this.props.average_kasm_duration))
                                                                : <React.Fragment>0s<br /></React.Fragment>
                                                            }
                                                            </React.Fragment>}
                                                    </strong>
                                                    <small className = "text-muted" style={{fontWeight: 'bold', whiteSpace: 'nowrap'}}>AVG TIME</small>
                                                </div>
                                            </div>
                                            <br />
                                            <br />
                                            <div style={{display:'inline-flex'}}>
                                                <div>
                                                    <i className="fa fa-exclamation-triangle bg-danger font-2xl p-3 mr-3"/>
                                                </div>
                                                <div>
                                                    {getErrorLoading ? <React.Fragment><Spinner size={'sm'} color={'danger'} /><br/></React.Fragment>
                                                        :
                                                        <React.Fragment>
                                                            <Link
                                                                to={{
                                                                pathname: '/logging',
                                                                state: {
                                                                    level: 'ERROR',
                                                                    start_date: this.props.selectOpen ? this.props.start_date : null,
                                                                    end_date: this.props.selectOpen ? this.props.end_date: null,
                                                                    delta: this.props.delta,
                                                                }
                                                            }}>
                                                                <strong className={"text-danger"}>{this.props.errors || 0}</strong><br />
                                                            </Link>
                                                        </React.Fragment>
                                                    }
                                                    <small className="text-muted" style={{fontWeight: 'bold'}}>ERRORS</small>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col sm={6}>
                                            <div style={{display:'inline-flex', paddingTop:'5px'}}>
                                                <div>
                                                    <i className="fa fa-users bg-success font-2xl p-3 mr-3" />
                                                </div>
                                                <div>
                                                    {getCurrentUsersLoading ? <React.Fragment><Spinner size={'sm'} color={'success'} /><br/></React.Fragment>
                                                        :
                                                        <React.Fragment>
                                                            <strong className={"text-success"}>
                                                                { current_users ? current_users
                                                                    : '0'}
                                                            </strong><br />
                                                        </React.Fragment>
                                                    }
                                                    <small className = "text-muted" style={{fontWeight: 'bold'}}>USERS</small>
                                                </div>
                                            </div>
                                            <br />
                                            <br />
                                            <div style={{display:'inline-flex'}}>
                                                <div>
                                                    <i className="fa fa-table bg-warning font-2xl p-3 mr-3"/>
                                                </div>
                                                <div>
                                                    {getCurrentKasmLoading ? <React.Fragment><Spinner size={'sm'} color={'warning'} /><br/></React.Fragment>
                                                        :
                                                        <React.Fragment>
                                                            <strong className={"text-warning"}>{current_kasms || 0}</strong><br />
                                                        </React.Fragment>
                                                    }
                                                    <small className="text-muted" style={{fontWeight: 'bold'}}>KASMS</small>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </Col >
                                <Col md={6} className="scrollbar" style={{minWidth: '305px'}}>
                                    <h4 style={{paddingTop: '15px'}}>Image Usage</h4>
                                    <div className="image_scroll">
                                        {getImageUseLoading ? <span className={"text-center"}><Spinner color='warning'/></span> :
                                            <ul style={{paddingInlineStart: '0px'}} >
                                                {img_progress && img_progress}
                                            </ul>
                                        }
                                    </div>
                                </Col>
                                <Col id="scroll">
                                    <h4 style={{paddingTop: '15px'}}>Live Sessions</h4>
                                    { this.props.live_kasms &&
                                    <KasmTable kasms={this.props.live_kasms} current_time={this.props.current_time}/>
                                    }
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </CardBody>
            </React.Fragment>
        );
    }
}

export default Tabs;


// WEBPACK FOOTER //
// ./src/views/Reporting/ReportDashboard/ReportComponents/UsageTab.js